var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('GenericListTable',{attrs:{"parentID":this.parentID,"title":"Devices","headers":[
      { text: 'ID', value: 'id' },
      { text: 'Device ID', value: 'devicename' },
      { text: 'Last Message Timestamp', value: 'datatime' },
      { text: 'Last Message Data', value: 'databytes' },
      { text: 'Device Location', value: 'identity_data.displayname', value2: 'displayname'},
      { text: 'Latitude', value: 'identity_data.loc_lat' },
      { text: 'Longitude', value: 'identity_data.loc_lon' }
    ],"url":"/schemas/devices","apiResponseField":"devices","onClickRoute":"DeviceTypeGraph","onClickParams":_vm.getOnClickParams,"onClickQuery":_vm.getOnClickQuery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }